import { lazy } from 'react';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const AdminManage = lazy(() => import('./pages/AdminManage'));
const PermissionManage = lazy(() => import('./pages/PermissionManage'));
const SystemConfig = lazy(() => import('./pages/SystemConfig'));
const UserManage = lazy(() => import('./pages/UserManage'));
const RefundManage = lazy(() => import('./pages/RefundManage'));
const OperationLog = lazy(() => import('./pages/OperationLog'));
const Profile = lazy(() => import('./pages/Profile'));
const OrderStats = lazy(() => import('./pages/OrderStats'));
const RechargeOrderManage = lazy(() => import('./pages/RechargeOrderManage'));
const DeliveryOrderManage = lazy(() => import('./pages/DeliveryOrderManage'));
const DeliveryManage = lazy(() => import('./pages/DeliveryManage'));
const DeliveryStats = lazy(() => import('./pages/DeliveryStats'));
const BucketReconcile = lazy(() => import('./pages/BucketReconcile'));
const NotificationLog = lazy(() => import('./pages/NotificationLog'));
const OaRisk = lazy(() => import('./pages/OaRisk'));
const ShopManage = lazy(() => import('./pages/ShopManage'));
const ShopDetail = lazy(() => import('./pages/ShopManage/ShopDetail'));
const ProfitSharing = lazy(() => import('./pages/ProfitSharing'));
const ProfitSharingReceiver = lazy(() => import('./pages/ProfitSharingReceiver'));

const routes = [
  { path: '/dashboard', Component: Dashboard },
  { path: '/admins', Component: AdminManage },
  { path: '/permissions', Component: PermissionManage },
  { path: '/system-config', Component: SystemConfig },
  { path: '/users', Component: UserManage },
  { path: '/refunds', Component: RefundManage },
  { path: '/operation-logs', Component: OperationLog },
  { path: '/profile', Component: Profile },
  { path: '/order-stats', Component: OrderStats },
  { path: '/recharge-orders', Component: RechargeOrderManage },
  { path: '/delivery-orders', Component: DeliveryOrderManage },
  { path: '/delivery-manage', Component: DeliveryManage },
  { path: '/delivery-stats', Component: DeliveryStats },
  { path: '/bucket-reconcile', Component: BucketReconcile },
  { path: '/notification-logs', Component: NotificationLog },
  { path: '/oa-risk', Component: OaRisk, platformOnly: true },
  { path: '/shops', Component: ShopManage, platformOnly: true },
  { path: '/shops/:id', Component: ShopDetail, platformOnly: true },
  { path: '/profit-sharing', Component: ProfitSharing, platformOnly: true },
  { path: '/profit-sharing-receivers', Component: ProfitSharingReceiver, platformOnly: true },
];

export default routes;